<script setup>
import StarsRating from '~/components/reviews/StarsRating'
const props = defineProps({
  book: {
    type: Object,
    required: true
  }
})

const book = toRef(props, 'book')
const { averageRating, numberOfRatings, bookRatingsLabel } = useReviews(
  book.value
)
</script>

<template>
  <section class="pr-lg-16">
    <div
      v-if="numberOfRatings"
      class="d-flex align-items-center mb-16 mb-lg-24"
    >
      <StarsRating :rating="averageRating" />
      <small class="text-small ml-8">
        {{ bookRatingsLabel }}
      </small>
    </div>

    <h1 class="mb-8 mb-lg-24" data-testid="book-title">
      {{ book.title }}
    </h1>

    <span v-if="book.author" class="text-large fw-semibold mb-24 d-block">
      {{ book.author.name }}
    </span>
  </section>
</template>
